import { datadogRum } from '@datadog/browser-rum';

if (import.meta.env.VITE_CONTRACT_DATADOG_ENABLED === 'true') {
  datadogRum.init({
    applicationId: 'e510061b-5f1c-417f-a863-f950099536bf',
    clientToken: 'pub5c47bf8aee4fc34168dfa905a44f292f',
    defaultPrivacyLevel: 'mask-user-input',
    env: import.meta.env.VITE_ENV,
    service: 'cnu-contract',
    sessionReplaySampleRate: 0,
    sessionSampleRate: 100,
    site: 'datadoghq.com',
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version: `${import.meta.env.VITE_GIT_COMMIT}-${import.meta.env.VITE_GIT_COMMIT_OVERLAYS}`,
  });
}

// Datadog's built-in user identity (@usr.id). A no-op until init has run.
export const identifyCustomerId = (customerId: string) => {
  datadogRum.setUser({ id: customerId });
};
